var React = require('react');

function FbInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook 로고"),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 10C20 4.47758 15.5224 0 10 0C4.47758 0 0 4.47758 0 10C0 14.9909 3.65634 19.1281 8.43765 19.8791V12.8913H5.8979V10H8.43765V7.79635C8.43765 5.29035 9.9311 3.90517 12.2149 3.90517C13.3089 3.90517 14.4537 4.10064 14.4537 4.10064V6.56165H13.1922C11.9505 6.56165 11.5623 7.33229 11.5623 8.124V9.99992H14.3355L13.8925 12.8912H11.5623V19.879C16.3436 19.1294 19.9999 14.9922 19.9999 9.99992L20 10Z","key":1})]);
}

FbInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = FbInline;

FbInline.default = FbInline;
